






































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { CourseListItem } from '@/store/modules/jtms/course/course.types';
import { CourseStatus } from '@/jbi-shared/types/jtms.types';
import dayjs from 'dayjs';
import { DateOrString } from '@/jbi-shared/types/full-document-revision-object.types';

@Component({})
export default class CourseRow extends Vue {
  @Prop(Object) public course!: CourseListItem;

  isCoursePublished: boolean = this.course.status === CourseStatus.PUBLISHED;

  getStatusDisplayName(status: string): string {
    switch (status) {
      case 'DRAFT':
        return 'Draft';
      case 'IN_PROGRESS':
        return 'In progress';
      case 'CANCELLED':
        return 'Cancelled';
      case 'PUBLISHED':
        return 'Published';
      case 'COMPLETED':
        return 'Completed';
      default:
        return 'Draft';
    }
  }

  getVisibilityDisplayName(visibility: string): string {
    switch (visibility) {
      case 'PRIVATE':
        return 'Private';
      case 'PUBLIC':
        return 'Public';
      default:
        return 'Private';
    }
  }

  getDateAsLocaleString(date: DateOrString): string {
    if (!date) {
      return '-';
    }
    return dayjs(date as string).format('D MMM YYYY');
  }
}
